import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

// 获取合作商池列表
export function listPartnerPool(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/partner.listPartnerPool',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取合作商适配列表
export function listPartnerAdapt(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/partner.listPartnerAdapt',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取合作商密钥列表
export function listPartnerKey(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/partner.listPartnerKey',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加合作商池
export function savePartnerPool(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/partner.savePartnerPool',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新合作商池
export function updatePartnerPool(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/partner.updatePartnerPool',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除合作商池
export function deletePartnerPool(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/partner.deletePartnerPool',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}